import React from 'react';
import './PrivacyPolicy.scss';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-container">
      <h1 className="title">Privacy Policy</h1>
      
      <p>Your privacy is important to us. This Privacy Policy explains how Your Move - Chris Stonock ("we", "our", or "us") collects, uses, and protects your personal data when you use our website or services. By using our services, you agree to the terms of this Privacy Policy.</p>

      <h2>1. Information We Collect</h2>
      <p>We may collect the following types of personal data when you use our property valuation services or interact with our website:</p>
      <ul>
        <li><strong>Personal Information:</strong> Your name, email address, phone number, and property-related information that helps us assess your property value.</li>
        <li><strong>Technical Data:</strong> Information collected through cookies and similar technologies for website functionality and tracking, including:
          <ul>
            <li>Google Ads monitoring</li>
            <li>Microsoft Clarity</li>
            <li>Cookies for improving website use (you can opt-out of cookies).</li>
          </ul>
        </li>
      </ul>

      <h2>2. How We Use Your Data</h2>
      <p>We collect and use your data for the following purposes:</p>
      <ul>
        <li>To provide you with an accurate property valuation.</li>
        <li>To assist with marketing, selling, or offering advice related to your property, should you choose to continue with our services.</li>
        <li>To improve our website's functionality and monitor its performance via third-party tracking tools.</li>
        <li>To market our services to you, based on your expressed interest.</li>
      </ul>

      <h2>3. How We Share Your Data</h2>
      <p>We may share your personal data with trusted third-party companies to help us provide our core property valuation, marketing, and sale services. However, we do not sell your personal data to any third parties.</p>

      <h2>4. User Rights and Control Over Your Data</h2>
      <p>You have the right to:</p>
      <ul>
        <li>Access, correct, or delete your personal data at any time.</li>
        <li>Opt out of receiving marketing communications from us.</li>
        <li>Manage your cookie preferences via your browser settings.</li>
      </ul>

      <h2>5. Data Retention</h2>
      <p>We will retain your personal data for as long as necessary to provide our services or for the duration required by law.</p>

      <h2>6. Contact Information</h2>
      <p>For more general privacy information or if you have any questions about our Privacy Policy, your data, or your rights, please find more information at:</p>
      <p><strong>Your Move - Chris Stonock</strong><br/>
        Website: <a href="https://www.your-move.co.uk/uploads/asset_file/YM%20Chris%20Stonock.pdf?cache=0f3a9d094aa0162e2a442ce0fa78ab4e">Your Move - Chris Stonock</a></p>

      <h2>7. Cookies and Tracking Technologies</h2>
      <p>Our website uses cookies to enhance your experience and track usage through tools such as Google Ads and Microsoft Clarity. You may disable cookies through your browser, although some features of our website may not function properly without them.</p>

      <h2>8. Changes to This Privacy Policy</h2>
      <p>We may update this Privacy Policy from time to time. Any changes will be posted on our website, and we recommend reviewing this policy regularly to stay informed of any updates.</p>
    </div>
  );
};

export default PrivacyPolicy;
